import { FC } from 'react'
import { Box } from '@mui/material'
import PageHeading from 'components/atoms/PageHeading'
import { useTranslation } from 'react-i18next'
import CurriculumMapSetupForm from 'components/organisms/forms/CurriculumMapSetupForm'

const CurriculumMapSetupPage: FC<{}> = () => {

  const { t } = useTranslation()

  return (
    <Box px={2}>
      <PageHeading title={t('setup-curriculum.unit-characteristics')} />
      <Box sx={{padding: '30px'}}><CurriculumMapSetupForm /></Box>
    </Box>
  )
}
export default CurriculumMapSetupPage
